import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CookieAgreementComponent } from './cookie-agreement.component';
import { CookieAgreementDirective } from './cookie-agreement.directive';

@NgModule({
  declarations: [CookieAgreementDirective, CookieAgreementComponent],
  imports: [CommonModule],
  exports: [CookieAgreementDirective],
})
export class CookieAgreementModule {}
